import React, { Component } from 'react'
import { Container, Table, Button, Spinner } from 'react-bootstrap'
import axios from 'axios'
import { withRouter } from 'react-router-dom'
import { AdminNav, Loading } from '../../helpers';
import Calendar from 'react-calendar';

class Job extends Component {
  constructor(props) {
    super(props);
    this.state = {
      RequestSheet: null,
      listInComplete: true,
      inCompleteLoading: false,
      completedLoading: false,
      CompanyList : [],

    }
    this.handleViewComplete = this.handleViewComplete.bind(this)
    this.handleViewInComplete = this.handleViewInComplete.bind(this)
    this.getCompanyName = this.getCompanyName.bind(this)
  }

  componentWillMount() {
    console.log(this.props)
    let RequestInComplete = axios.post(
      'https://us-central1-riceinspection-16b06.cloudfunctions.net/middleWare',
      {
        action: 'viewAllRequestSheetInCompleteByDate',
        data: { 'timeValue': this.props.history.location.state },
      }
    )
    let RequestComplete = axios.post(
      'https://us-central1-riceinspection-16b06.cloudfunctions.net/middleWare',
      {
        action: 'viewAllRequestSheetCompleteByDate',
        data: { 'timeValue': this.props.history.location.state },
      }
    )
    let Company = axios.post(
      'https://us-central1-riceinspection-16b06.cloudfunctions.net/middleWare',
      {

        action: 'viewAllCompany',
      }
    )
    Promise.all([RequestInComplete,Company,RequestComplete])
    .then((res)=>{
      RequestInComplete = res[0]
      Company = res[1]
      RequestComplete = res[2]
      this.setState({
        ...this.state,
        RequestSheet : RequestInComplete.data,
        listInComplete : true,
        CompanyList : Company.data,
        RequestSheetComplete : RequestComplete.data,
      })
    })
  }
  handleTableClick = (e) => {
    console.log(e.target.parentElement.id)
    this.props.history.push({
      pathname: '/AddJob',
      state: this.state.RequestSheet[e.target.parentElement.id],
      date: this.props.history.location.state,
      RequestSheetChain: this.state.RequestSheetComplete,
    })
  }
  handleViewInComplete() {
    this.setState({ inCompleteLoading: true });
    axios.get(
      'https://us-central1-riceinspection-16b06.cloudfunctions.net/middleWare',
      {
        params: {
          'action': 'viewAllRequestSheetInComplete',
        },
      }
    ).then(res => {
      this.setState({
        RequestSheet: res.data,
        listInComplete: true,
        inCompleteLoading: false,
      })
    })
  }
  handleViewComplete() {
    this.setState({ completedLoading: true });
    axios.get(
      'https://us-central1-riceinspection-16b06.cloudfunctions.net/middleWare',
      {
        params: {
          'action': 'viewAllRequestSheetComplete',
        },
      }
    ).then(res => {
      this.setState({
        RequestSheet: res.data,
        listInComplete: false,
        completedLoading: false,
      })
    })
  }
  getCompanyName(id){
    let output = ''
    Object.keys(this.state.CompanyList).map((data)=>{
      if(this.state.CompanyList[data].companyID == id){
        output = this.state.CompanyList[data].companyNameEN
      }
    })
    return output
  }
  render() {
    let { RequestSheet, inCompleteLoading, completedLoading,listInComplete } = this.state;
    if (!RequestSheet) {
      return (<Container>
        <AdminNav></AdminNav>
        <Loading />
      </Container>
      )
    }
    return (
      <Container>
        <AdminNav></AdminNav>
        {/* <Nav className="justify-content-end">
                    <Link to={{ pathname: '/AddJob', state:  'bar' }}><Button variant="success">เพิ่ม</Button></Link>
                </Nav> */}


        <Table bordered hover>
          <thead>
            <tr>
              <th>วันบรรทุกสินค้า</th>
              <th>จังหวัดบรรทุก</th>
              <th>อำเภอบรรทุก</th>
              <th>สถานที่บรรทุก</th>
              <th>Order NO.</th>
              <th>ชื่อบริษัท</th>
            </tr>
          </thead>
          <tbody>
            {Object.keys(this.state.RequestSheet).map((res) => {
              let c = this.state.RequestSheet[res]
              console.log('this c ')

              if (res === 'requestCount') {
                return null;
              }
              if (this.state.listInComplete === false) {
                return (
                  <tr id={res}>
                    <td>{c.shippingDate}</td>
                    <td>{c.surveyProvince}</td>
                    <td>{c.surveyDistrict}</td>
                    <td>{c.surveyLocateName}</td>
                    <td>{c.requestID}</td>
                    <td>{this.getCompanyName(c.companyID)}</td>
                  </tr>
                )
              } else {
                return (
                  <tr id={res} onClick={this.handleTableClick}>
                    <td>{c.shippingDate}</td>
                    <td>{c.surveyProvince}</td>
                    <td>{c.surveyDistrict}</td>
                    <td>{c.surveyLocateName}</td>
                    <td>{c.requestID}</td>
                    <td>{this.getCompanyName(c.companyID)}</td>
                  </tr>
                )
              }
            })}
          </tbody>
        </Table>
        <div align="center">
          <Button variant={listInComplete ? 'info' : 'outline-info'} onClick={this.handleViewInComplete} disable={inCompleteLoading}>
            {inCompleteLoading ? <Spinner animation="border" /> :'คำสั่งจ่ายงานที่ไม่ได้แจกงาน'}
          </Button>
          <br />
          <br />
          <Button variant={listInComplete ? 'outline-info' : 'info'} onClick={this.handleViewComplete} disable={completedLoading}>
            {completedLoading ? <Spinner animation="border" /> : 'คำสั่งจ่ายงานที่แจกงานเรียบร้อย'}
          </Button>
        </div>

      </Container>
    )
  }
}


export default withRouter(Job);
